import React from 'react';
import { motion } from 'framer-motion';
import { SUPPORTED_FORMATS, getCompatibleFormats } from '../utils/imageConverter';

const FormatSelector = ({ sourceFormat, selectedFormat, onFormatChange, disabled }) => {
  const compatibleFormats = sourceFormat ? getCompatibleFormats(sourceFormat) : [];

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.1 }}
      className="w-full"
    >
      <label htmlFor="format-select" className="block text-sm font-medium text-primary-600 mb-2">
        Konvertieren zu:
      </label>
      <select
        id="format-select"
        value={selectedFormat || ''}
        onChange={(e) => onFormatChange(e.target.value)}
        disabled={disabled || !sourceFormat}
        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed text-primary-600"
      >
        <option value="">Format auswählen...</option>
        {compatibleFormats.map((format) => (
          <option key={format} value={format}>
            {SUPPORTED_FORMATS[format].label} (.{SUPPORTED_FORMATS[format].extension})
          </option>
        ))}
      </select>
      {sourceFormat && compatibleFormats.length === 1 && (
        <p className="text-xs text-amber-600 mt-1">
          SVG-Dateien können nur als SVG beibehalten werden. Raster-Konvertierung erfordert Vektorisierung.
        </p>
      )}
    </motion.div>
  );
};

export default FormatSelector;